import { Tables } from "@/lib/supabase/supabaseTypes";
import { v4 as uuidv4 } from "uuid";
import {
  Exercise,
  ExerciseSet,
  TrackingType,
} from "@/components/workouts/workoutsColumns";

const createDefaultSet = (trackingType: TrackingType | null): ExerciseSet => {
  if (trackingType === "timed") {
    return { id: uuidv4() };
  }

  if (trackingType?.startsWith("distance")) {
    return { id: uuidv4() };
  }

  return {
    id: uuidv4(),
    startRange: 10,
    endRange: 12,
  };
};

export const createWorkoutExercise = ({
  exercise,
  exOrder,
  subOrder,
  sectionId,
}: {
  exercise: Tables<"exercises">;
  exOrder: number;
  subOrder: number;
  sectionId?: string | null;
}): Exercise => {
  const trackingType = (exercise.tracking_type ?? "strength") as TrackingType;

  return {
    ...exercise,
    sets: [{ ...createDefaultSet(trackingType), set_type: "working" }],
    rest_time: null,
    rir: null,
    tempo: "",
    coach_note: null,
    ex_order: exOrder,
    sub_order: subOrder,
    sortableId: uuidv4(),
    section_id: sectionId ?? null,
    workout_exercise_id: uuidv4(),
  };
};
